import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

interface ActiveFilterChipProps {
  label: string;
  onClear: () => void;
  "data-testid"?: string;
}

export function ActiveFilterChip({ label, onClear, "data-testid": testId }: ActiveFilterChipProps) {
  return (
    <Badge variant="secondary" className="gap-1 pl-2 pr-1">
      {label}
      <button
        onClick={onClear}
        className="rounded-sm opacity-70 hover:opacity-100 ml-0.5"
        data-testid={testId}
      >
        <X className="h-3 w-3" />
      </button>
    </Badge>
  );
}
